
<script>
export default {
    data() {
        return {
            show: false
        };
    },
    methods: {
        toggle: function() {
            this.show = !this.show;
        },
        beforeEnter: function(el) {
            el.style.height = '0';
        },
        enter: function(el) {
            el.style.height = el.scrollHeight + 'px';
        },
        beforeLeave: function(el) {
            el.style.height = el.scrollHeight + 'px';
        },
        leave: function(el) {
            el.style.height = '0';
        }
    }
};
</script>
